// A gated video opens the paywall instead of playing. An unlocked video, or a
// video with no gate, plays immediately.
export const requestVideoPlayback = ({
  hasGate,
  isUnlocked,
  start,
  openGate,
}: {
  hasGate: boolean;
  isUnlocked: boolean;
  start: () => void;
  openGate: () => void;
}) => {
  if (!hasGate || isUnlocked) {
    start();
    return;
  }

  openGate();
};
